import React from "react";
import {useConsumerMenu} from "../context/MenuContext";
import DashboardMenuContent from "../dashboard-menu/DashboardMenuContent";

const PostPlanOptions = () => {
  const {handleClose} = useConsumerMenu();

  return <DashboardMenuContent onClose={handleClose} hasDivider />;
};

export default PostPlanOptions;
